import { FEATURE_FLAGS } from '@ruta/shared';
import { useOrganization } from './useQueries';

/**
 * Server-evaluated PostHog flags for the signed-in org (from GET /organization/profile).
 * Prefer this over client-side `posthog.isFeatureEnabled` for payment gates —
 * the API is the authority for schedule enforcement.
 */
export function useOrgFeatures() {
  const { data, isLoading } = useOrganization();
  const features = data?.features ?? {};
  return {
    isLoading,
    features,
    skipJustifiRegistration: features[FEATURE_FLAGS.SKIP_JUSTIFI_REGISTRATION] === true,
  };
}
